import React, { useState, useEffect } from 'react'
import TaskForm from '../TaskForm/TaskForm';
import './style.scss'
import { homeTaskIcon } from '../../utils/images'
import { injectIntl } from "react-intl";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../store/Tasks/actions";

function TasksCol({ intl: { messages } }) {
    const dispatch = useDispatch();
    const { taskStatistics } = useSelector((state) => state?.tasks);
    const [totalTasks, setTotalTasks] = useState(0);
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        dispatch(actions.tasksStatisticsRequest());
        return () => {
            dispatch(actions.tasksStatisticsReceive());
        }
    }, [dispatch]);

    const reloadData = () => {
        dispatch(actions.tasksStatisticsRequest());
    }

    useEffect(() => {
        if (taskStatistics) {
            setTotalTasks(
                parseInt(taskStatistics.new) + 
                parseInt(taskStatistics.inprogress) + 
                parseInt(taskStatistics.inprogress_with_delay) + 
                parseInt(taskStatistics.completed) +
                parseInt(taskStatistics.completed_with_delay)
            );
        }
    }, [taskStatistics]);

    const options = {
        chart: {
            width: '300',
            height: '280',
            spacing: [0, 0, 0, 0],
            backgroundColor: 'transparent',
            type: 'pie',
            options3d: {
                enabled: false,
            }
        },
        credits: {
            enabled: false
        },
        title: {
            text: '<a  href="/tasks">' + totalTasks + '<br />' + messages.home.chart.tasks + '</a>',
            align: 'center',
            verticalAlign: 'middle',
            style: {
                    fontWeight: 'bold',
                    color: '#AAA',
                    fontSize: '15px'
            }
        },
        plotOptions: {
          pie: {
            center: ['50%', '50%'],
            innerSize: 100,
            depth: 0,
            opacity: 0.9,
            borderWidth: 0,
            dataLabels: {
                distance: 10,
                color: '#666',
                style: {'font-size': '10px'},
                crookDistance: '100%',
            },
          }
        },
        series: [{
          type: 'pie',
          name: 'Tasks',
          data: [
                {
                    name: `${messages.home.chart.newTasks}`,
                    color: "#55D8FE",
                    y: parseInt(taskStatistics?.new),
                    dataLabels: {
                        enabled: parseInt(taskStatistics?.new) > 0 ? true : false,
                    },
                },
                {
                    name: `${messages.home.chart.inProgress}`,
                    color: "#FF8373",
                    y: parseInt(taskStatistics?.inprogress),
                    dataLabels: {
                        enabled: parseInt(taskStatistics?.inprogress) > 0 ? true : false,
                    },
                },
                {
                    name: `${messages.home.chart.late}`,
                    color: "#FFDA83",
                    y: parseInt(taskStatistics?.inprogress_with_delay),
                    dataLabels: {
                        enabled: parseInt(taskStatistics?.inprogress_with_delay) > 0 ? true : false,
                    },
                },
                {
                    name: `${messages.home.chart.completed}`,
                    color: "#A3A0FB",
                    y: parseInt(taskStatistics?.completed),
                    dataLabels: {
                        enabled: parseInt(taskStatistics?.completed) > 0 ? true : false,
                    },
                },
                {
                    name: `${messages.home.chart.completed_late}`,
                    color: "rgb(200,146,225)",
                    y: parseInt(taskStatistics?.completed_with_delay),
                    dataLabels: {
                        enabled: parseInt(taskStatistics?.completed_with_delay) > 0 ? true : false,
                    },
                }
          ]
        }]
    }

    return (
        <div className='tasks-col'>
            <section className='tasks-col_mytasks'>
                <h3>{messages.home.myTasks}</h3>
                <div className='tasks-col_mytasks_chart'>
                   {taskStatistics ? 
                    <HighchartsReact highcharts={Highcharts} options={options} />
                   : null}
                </div>
            </section>
            <div className="newTaskBtn" onClick={(e) => setShowForm(true)}>
                <span>{messages.home.taskBtn}</span>
                <img src={homeTaskIcon} alt="users" />
            </div>
            <TaskForm show={showForm} close={() => setShowForm(false)} task={null} view={false} reloadData={reloadData} />
        </div>
    )
}

export default injectIntl(TasksCol);
